import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React from 'react'
import PDetailsTab from './PDetailsTab'
import PActiveEvalList from './PActiveEvalList'
import PCompletedEvalList from './PCompletedEvalList'
import PTeamMembers from './PTeamMembers'
import { useLocation } from 'react-router-dom'
import { Box } from '@mui/material'

const PTabs = ({
  appraisalId,
  appraisalScore,
  isManager,
  staffId,
  status,
  start_date,
  end_date,
  description,
  evaluations,
  total_submission,
}) => {
  const { state } = useLocation()
  return (
    <Box bgcolor={'background.main'} borderRadius={'4.5px'} overflow={'clip'}>
      <AdxTabsBadge
        initialValue={state.initialTabsValue ? state.initialTabsValue : 0}
        sxPanel={{
          overflow: 'auto',
          borderRadius: 0,
          maxHeight: 'calc(100vh - 295px)',
        }}
        scrollButtons={false}
        tabsBorderBottom
        whiteBackground
        sxTabs={{
          border: 1,
          borderRadius: '4.5px',
          borderColor: 'gray-line.main',
        }}
      >
        <AdxTabsPanel label="Details">
          <PDetailsTab
            status={status}
            start_date={start_date}
            end_date={end_date}
            description={description}
          />
        </AdxTabsPanel>

        <AdxTabsPanel label="Evaluation" notification={total_submission}>
          <PActiveEvalList evaluations={evaluations} status={status} />
        </AdxTabsPanel>

        <AdxTabsPanel label="My Score">
          <PCompletedEvalList
            evaluations={evaluations}
            appraisalScore={appraisalScore}
            status={status}
          />
        </AdxTabsPanel>

        {isManager?.length !== 0 && (
          <AdxTabsPanel label="Team Members">
            <PTeamMembers managerId={staffId} appraisalId={appraisalId} />
          </AdxTabsPanel>
        )}
      </AdxTabsBadge>
    </Box>
  )
}

export default PTabs
